import type { PlanId } from "@/constants/tier";

/**
 * The plan a visitor picked on the pricing page has to survive every way into
 * the checkout step: email signup → code or magic link (often opened in another
 * tab), Google sign-up/sign-in (round-trips through Google and the backend
 * relay), and a returning user who logs in instead. `?plan=` on the URL is the
 * primary channel; this short-lived, host-only cookie is the fallback that the
 * server-side hand-offs read when the parameter got lost on the way.
 * Not sensitive — a display preference the user can change on /start.
 */
export const PLAN_COOKIE = "cf_plan";
export const PLAN_COOKIE_MAX_AGE = 60 * 60; // 1 h — long enough for "check your mail"

const PLAN_ID = /^(solo|team)-(monthly|yearly)$/;

/** "solo-yearly" → "solo-yearly"; legacy "monthly"/"yearly" → the Team plan; junk → null. */
export function normalizePlanId(raw: string | null | undefined): PlanId | null {
  const v = (raw || "").trim().toLowerCase();
  if (PLAN_ID.test(v)) return v as PlanId;
  if (v === "monthly" || v === "yearly") return `team-${v}` as PlanId;
  return null;
}

/** document.cookie string that remembers the pick (client side, pricing page). */
export function planCookieString(plan: PlanId, secure: boolean): string {
  return `${PLAN_COOKIE}=${plan}; Max-Age=${PLAN_COOKIE_MAX_AGE}; Path=/; SameSite=Lax${secure ? "; Secure" : ""}`;
}
